__turbopack_context__.v({
  "closeButton": "form-module-scss-module__sYwAHW__closeButton",
  "container": "form-module-scss-module__sYwAHW__container",
  "form": "form-module-scss-module__sYwAHW__form",
  "formWrapper": "form-module-scss-module__sYwAHW__formWrapper",
  "hide": "form-module-scss-module__sYwAHW__hide",
  "submitButton": "form-module-scss-module__sYwAHW__submitButton",
});
